import React, { useEffect } from "react";

import useFilter from "../../../../hooks/useFilter";
import scrollToTop from "../../../../libs/scrollToTop";
import { calculatePageSize } from "../../../../libs/pagingDetail";

import LoadingComponent from "../../../../components/public/loading";
import PaginationComponent from "../../../../components/public/pagination";
import UserFinancialListCompanyComponent from "../../../../components/private/user/userFinancialComponents/userFinancialListCompanyComponent";

function UserFinancialListPersonalContainer({ loading, financialData }) {
  const { onChange, filterState } = useFilter();

  useEffect(() => {
    document.title = "سفارش‌های من";
    scrollToTop();
  }, []);

  useEffect(() => {
    onChange("page", 1);
  }, [filterState["tab"]]);

  return (
    <>
      {loading ? (
        <LoadingComponent />
      ) : (
        <>
          <UserFinancialListCompanyComponent
            financialData={financialData?.results}
          />
          <PaginationComponent
            pageNumber={calculatePageSize(
              financialData?.count,
              filterState["page_size"]
            )}
            currentPage={filterState["page"] || 1}
            handleChangePage={(e, value) => {
              onChange("page", value);
            }}
            className="mt-5"
            defaulPage={1}
          />
        </>
      )}
    </>
  );
}

export default UserFinancialListPersonalContainer;
